import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Tab, TabList, Divider } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { TABLIST } from './constants/index';
import { getTabListStyles } from './style/tab-list-style';

export const KeywordTab = ({
  selectedTab,
  onTabSelect,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getTabListStyles);

  return (
    <div className={classes.root}>
      <TabList selectedValue={selectedTab} onTabSelect={onTabSelect}>
        <Tab value={TABLIST.GROUP}>{i18n.getString(_TL_('Keyword grouping'))}</Tab>
        <Tab value={TABLIST.RANK}>{i18n.getString(_TL_('Keyword ranking'))}</Tab>
      </TabList>
      <Divider className={classes.divider} />
    </div>
  );
};

KeywordTab.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  onTabSelect: PropTypes.func.isRequired,
};
